import {Component} from "../Component";
import * as s from "../../../../sass/imports/loading-button.scss";
import {LoaderLightComponent} from "../../../../../products/components/global/loader/light/LoaderLightComponent";

export function setLoadingButton(button?: Component, width?: number, strokeColor?: string) {
    if (button) {
        button.addClass(s.loadingButton);
        button['LoaderLightComponent'] = new LoaderLightComponent({width: width ? width : 22, strokeColor: strokeColor});
        button.render(button['LoaderLightComponent']);
    }
}

export function remLoadingButton(button?: Component) {
    if (button) {
        button.removeClass(s.loadingButton);

        if (button['LoaderLightComponent'])
            button['LoaderLightComponent'].remove();
    }
}